import { useTranslation } from "react-i18next";
import {
  BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./BaseSelect";
import { useEffect, useState } from "react";

const Select = ({
  placeholder = "Seleccione uno",
  options,
  onValueChange,
  defaultValue,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue);

  const onValueChangeHandler = (value) => {
    setValue(value);
    onValueChange(value);
  };

  useEffect(() => {
    if (defaultValue === undefined) {
      setValue("");
    }
  }, [options]);

  return (
    <BaseSelect
      value={value}
      onValueChange={onValueChangeHandler}
      defaultValue={defaultValue}
      disabled={isDisabled}
    >
      <SelectTrigger>
        <SelectValue placeholder={t(placeholder)} />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </BaseSelect>
  );
};

export default Select;
